'use client';

import { useEffect, useState } from 'react';
import { DoneIcon } from './icon.done';
interface IHeaderProps {
  overallStatus: string;
}
export const Header: React.FC<IHeaderProps> = ({
  overallStatus
}) => {
  const [currentTime, setCurrentTime] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className='flex w-full flex-col items-center justify-center py-24 text-center'>
      <div className='size-16'>
        <DoneIcon />
      </div>
      <h2 className='font-bold text-4xl'>All services are {overallStatus}</h2>
      <p className='mt-1 opacity-60'>
        Real-time monitoring across all regions{' '}
        {currentTime.toLocaleTimeString()}
      </p>
    </div>;
};